import React from 'react';

export type TagVariant = 'root-cause' | 'outcome' | 'vulnerability' | 'strain' | 'harm' | 'consumer-duty' | 'business-context';

interface SignalTagProps {
  label: string;
  variant: TagVariant;
  className?: string;
  selected?: boolean;
}

const SignalTag: React.FC<SignalTagProps> = ({ label, variant, className = '', selected = false }) => {
  const formatLabel = (raw: string): string => {
    if (!raw) return '';
    // Replace underscores/hyphens with spaces and collapse whitespace
    const normalized = raw.replace(/[\-_]+/g, ' ').replace(/\s+/g, ' ').trim();
    // Title-case each word
    return normalized
      .split(' ')
      .map(w => (w.length === 0 ? '' : w[0].toUpperCase() + w.slice(1).toLowerCase()))
      .join(' ');
  };
  const getVariantStyles = () => {
    if (selected) {
      switch (variant) {
        case 'root-cause':
          return 'border-pink text-white bg-pink';
        case 'outcome':
          return 'border-teal text-white bg-teal';
        case 'vulnerability':
          return 'border-purple text-white bg-purple';
        case 'strain':
          return 'border-purple text-white bg-purple';
        case 'harm':
          return 'border-berry text-white bg-berry';
        case 'consumer-duty':
          return 'border-blue-600 text-white bg-blue-600';
        case 'business-context':
          return 'border-gray-400 text-white bg-gray-400';
        default:
          return 'border-gray-300 text-white bg-gray-300';
      }
    } else {
      switch (variant) {
        case 'root-cause':
          return 'border-pink text-pink bg-white';
        case 'outcome':
          return 'border-teal text-teal bg-white';
        case 'vulnerability':
          return 'border-purple text-purple bg-white';
        case 'strain':
          return 'border-purple text-purple bg-white';
        case 'harm':
          return 'border-berry text-berry bg-white';
        case 'consumer-duty':
          return 'border-blue-600 text-blue-600 bg-white';
        case 'business-context':
          return 'border-gray-400 text-gray-700 bg-white';
        default:
          return 'border-gray-300 text-gray-600 bg-white';
      }
    }
  };

  return (
    <span 
      className={`px-3 py-1 border-2 text-xs rounded font-medium ${getVariantStyles()} ${className}`}
      style={{ fontFamily: 'Open Sans, sans-serif' }}
    >
      {formatLabel(label)}
    </span>
  );
};

export default SignalTag;